import {
  ChangeDetectionStrategy,
  Component,
  HostBinding,
  Input,
  OnInit,
} from '@angular/core';
import { IconRegistryService } from '@rd/core/services/icon-registry/icon-registry.service';

@Component({
  selector: 'rd-sc-header-icon',
  templateUrl: './sc-header-icon.component.html',
  styleUrls: [],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AnzScHeaderIconComponent implements OnInit {
  @HostBinding('class.rd-sc-header-icon') componentClass = true;
  @Input() itemCount: number;

  constructor(private iconRegistryService: IconRegistryService) {}

  ngOnInit(): void {
    this.iconRegistryService.registerIcon('cart');
  }

  formatItemCount(count: number): string {
    if (count > 99) {
      return '99+';
    } else {
      return count.toString();
    }
  }

  getAriaLabel(count: number): string {
    if (count === 0) {
      return 'wl.anz.accessibility.cart_item_empty';
    }
    if (count === 1) {
      return 'wl.anz.accessibility.cart_item_one';
    }
    if (count > 99) {
      return 'wl.anz.accessibility.cart_item_hundred_up';
    } else {
      return 'wl.anz.accessibility.cart_item_multiple';
    }
  }
}
